<template>
  <Header />
  <Container>
    <template #title>Create your brand account</template>
    <template #form>
      <form class="form p-fluid" @submit.prevent="submit">
        <FormField title="First name" v-model="user.first_name" :required="true" placeholder="Enter your first name" :error="getError('first_name')"/>
        <FormField title="Last name" v-model="user.last_name" :required="true" placeholder="Enter your last name" :error="getError('last_name')"/>
        <FormField title="Email" v-model="user.email" :required="true" placeholder="Enter your email" :error="getError('email')" type="email"/>
        <FormField title="Password" v-model="user.password" componentType="password" :required="true" placeholder="Create your password" :error="getError('password')" :toggleMask="true" :feedback="false" />
        <FormField title="How did you find out about Native?" v-model="user.source" componentType="select" :options="source" optionLabel="label" optionValue="value" placeholder="Choose an option" :error="getError('source')" :required="true"/>
        <div class="form-buttons">
          <Button type="submit" label="Create Account" class="p-button-md" />
        </div>
        <div class="note">
          By signing up you agree to the Native
          <a target="_blank" href="https://www.nativeugc.com/terms-and-conditions">Terms of Service</a>
          and
          <a target="_blank" href="https://www.nativeugc.com/privacy">Privacy Policy</a>
          .
        </div>

        <div class="to-login">
          Already have an account?
          <router-link :to="{name: 'login'}">
            Log In
          </router-link>
        </div>
      </form>
    </template>
  </Container>
</template>

<script setup>
import Header from "./Header";
import FormField from "../../../components/FormField";
import {useForm} from "../../../hooks/useForm";
import {reactive} from "vue";
import Container from "./Container";
import {useUser} from "../../../hooks/useUser";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed} from 'vue';
import {getUserSources} from "../../../queries/userQueries";

const store = useStore();
const router = useRouter()
const {registerAsBrand} = useUser();

const user = reactive({});

const {data: sourceData} = getUserSources();

const source = computed(() => sourceData.value?.data || []);

const {busy, submit, getError} = useForm(async () => {
  await registerAsBrand(user);
  await store.dispatch('auth/user');
  await router.push({'name': 'register.brand.setup'});
});
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.form-buttons {
  margin-top: toRem(24);
}

.note {
  margin-top: toRem(10);
  font-size: toRem(12);
  color: $textThirdColor;

  a {
    color: $textThirdColor;
  }
}

.to-login {
  margin-top: toRem(16);
}
</style>
